import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "control-favorite control-favorite-add" }
const _hoisted_3 = { class: "control-favorite control-favorite-remove" }

import { computed, onBeforeMount, ref, watch } from 'vue'

import type { DocView } from '@/models/doc'
import { DocFavoriteView } from '@/models/doc.favorite'
import { assertNotNull } from '@/helpers/typing'


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarFavorite',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props

const view = ref<DocFavoriteView | null>(null)

onBeforeMount(() => {
  view.value = new DocFavoriteView(props.doc)
})

watch(
  () => props.doc,
  (newValue) => {
    view.value = new DocFavoriteView(newValue)
  },
  { deep: false },
)

async function favoriteToggle($event: Event): Promise<void> {
  await assertNotNull(view.value).favoriteToggle($event)
}

const showAdded = computed(() => {
  return assertNotNull(view.value).hint === 'adding'
})

const showRemoved = computed(() => {
  return assertNotNull(view.value).hint === 'removing'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([{
      'control__btn--favorite': __props.doc.user.is_favorite,
    }, "control__btn favorite-btn"]),
    title: "Add to favorites",
    disabled: view.value?.buttonDisabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (favoriteToggle($event)))
  }, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "control__icon-box" }, [
      _createElementVNode("span", { class: "control__icon iconfont icontrol-favorite" }),
      _createElementVNode("span", { class: "control__icon control__icon--active control__icon--favorite iconfont ifavorite" })
    ], -1)),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "control-favorite__flex-box" }, [
            _createElementVNode("span", { class: "control-favorite__icon iconfont ifavorite" }),
            _createTextVNode("Adding to Favorites ")
          ], -1)
        ]))], 512), [
          [_vShow, showAdded.value]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "control-favorite__flex-box" }, [
            _createElementVNode("span", { class: "control-favorite__icon iconfont icontrol-favorite" }),
            _createTextVNode("Removing from Favorites ")
          ], -1)
        ]))], 512), [
          [_vShow, showRemoved.value]
        ])
      ]),
      _: 1
    })
  ], 10, _hoisted_1))
}
}

})